import { createSelector } from 'reselect';

const selectMain = (state) => state.main;

// DIAGRAMS LIST
export const selectDiagramsList = createSelector(
    [selectMain],
    (main) => main.diagrams
);

// TEMPLATES LIST
export const selectTemplatesList = createSelector(
    [selectMain],
    (main) => main.templates
);

// SIDEBAR
export const selectIsSidebarCollapsed = createSelector(
    [selectMain],
    (main) => main.isSidebarCollapsed
);
export const selectIsSidebarProfileMenuEnabled = createSelector(
    [selectMain],
    (main) => main.isSidebarProfileMenuEnabled
);

// DIAGRAM RENAME
export const selectIsModalDiagramRenameEnabled = createSelector(
    [selectMain],
    (main) => main.isModalDiagramRenameEnabled
);
export const selectModalDiagramRenameData = createSelector(
    [selectMain],
    (main) => main.modalDiagramRenameData
);

// DIAGRAM CLONE
export const selectIsModalDiagramCloneEnabled = createSelector(
    [selectMain],
    (main) => main.isModalDiagramCloneEnabled
);
export const selectModalDiagramCloneData = createSelector(
    [selectMain],
    (main) => main.modalDiagramCloneData
);

// DIAGRAM SOFT DELETE (ARCHIVE)
export const selectIsModalDiagramSoftDeleteEnabled = createSelector(
    [selectMain],
    (main) => main.isModalDiagramSoftDeleteEnabled
);
export const selectModalDiagramSoftDeleteData = createSelector(
    [selectMain],
    (main) => main.modalDiagramSoftDeleteData
);
export const selectIsDiagramCanvasDeleted = createSelector(
    [selectMain],
    (main) => main.isDiagramCanvasDeleted
);
export const selectIsDiagramCanvasNotFound = createSelector(
    [selectMain],
    (main) => main.isDiagramCanvasNotFound
);


// DIAGRAM DELETE
export const selectIsModalDiagramDeleteEnabled = createSelector(
    [selectMain],
    (main) => main.isModalDiagramDeleteEnabled
);
export const selectModalDiagramDeleteData = createSelector(
    [selectMain],
    (main) => main.modalDiagramDeleteData
);

// DIAGRAM RESTORE
export const selectIsModalDiagramRestoreEnabled = createSelector(
    [selectMain],
    (main) => main.isModalDiagramRestoreEnabled
);
export const selectModalDiagramRestoreData = createSelector(
    [selectMain],
    (main) => main.modalDiagramRestoreData
);

// DIAGRAM SHARE
export const selectIsModalDiagramShareEnabled = createSelector(
    [selectMain],
    (main) => main.isModalDiagramShareEnabled
);
export const selectModalDiagramShareData = createSelector(
    [selectMain],
    (main) => main.modalDiagramShareData
);



// TEMPLATE CLONE
export const selectIsModalTemplateCloneEnabled = createSelector(
    [selectMain],
    (main) => main.isModalTemplateCloneEnabled
);
export const selectModalTemplateCloneData = createSelector(
    [selectMain],
    (main) => main.modalTemplateCloneData
);

// DIAGRAM CREATE
export const selectIsModalDiagramCreateEnabled = createSelector(
    [selectMain],
    (main) => main.isModalDiagramCreateEnabled
);
export const selectModalDiagramCreateData = createSelector(
    [selectMain],
    (main) => main.modalDiagramCreateData
);

export const selectIsModalDiagramCreateNewEnabled = createSelector(
    [selectMain],
    (main) => main.isModalDiagramCreateNewEnabled
);
export const selectModalDiagramCreateNewData = createSelector(
    [selectMain],
    (main) => main.modalDiagramCreateNewData
);


// DIAGRAM IMPORT SQL
export const selectIsModalDiagramImportSqlEnabled = createSelector(
    [selectMain],
    (main) => main.isModalDiagramImportSqlEnabled
);
export const selectModalDiagramImportSqlData = createSelector(
    [selectMain],
    (main) => main.modalDiagramImportSqlData
);

// DIAGRAM DETAILS
export const selectIsModalDiagramDetailsEnabled = createSelector(
    [selectMain],
    (main) => main.isModalDiagramDetailsEnabled
);
export const selectModalDiagramDetailsData = createSelector(
    [selectMain],
    (main) => main.modalDiagramDetailsData
);

// TEMPLATE DETAILS
export const selectIsModalTemplateDetailsEnabled = createSelector(
    [selectMain],
    (main) => main.isModalTemplateDetailsEnabled
);
export const selectModalTemplateDetailsData = createSelector(
    [selectMain],
    (main) => main.modalTemplateDetailsData
);

// PRICING PLAN
export const selectIsModalPricingPlanUpgradeEnabled = createSelector(
    [selectMain],
    (main) => main.isModalPricingPlanUpgradeEnabled
);
export const selectModalPricingPlanUpgradeData = createSelector(
    [selectMain],
    (main) => main.modalPricingPlanUpgradeData
);

export const selectIsModalPricingPlanLimitEnabled = createSelector(
    [selectMain],
    (main) => main.isModalPricingPlanLimitEnabled
);
export const selectModalPricingPlanLimitType = createSelector(
    [selectMain],
    (main) => main.modalPricingPlanLimitType
);

// SUPPORT
export const selectIsModalSupportEnabled = createSelector(
    [selectMain],
    (main) => main.isModalSupportEnabled
);
export const selectModalSupportData = createSelector(
    [selectMain],
    (main) => main.modalSupportData
);

export const selectFeedbackSentStatus = createSelector(
    [selectMain],
    (main) => main.feedbackSentStatus
);

// FEEDBACK THANKS
export const selectIsModalFeedbackThanksEnabled = createSelector(
    [selectMain],
    (main) => main.isModalFeedbackThanksEnabled
);
export const selectModalFeedbackThanksData = createSelector(
    [selectMain],
    (main) => main.modalFeedbackThanksData
);


// INVITE PEOPLE
export const selectIsModalInvitePeopleEnabled = createSelector(
    [selectMain],
    (main) => main.isModalInvitePeopleEnabled
);
export const selectInviteSentStatus = createSelector(
    [selectMain],
    (main) => main.inviteSentStatus
);

// MODAL LANGUAGES
export const selectIsModalLanguagesEnabled = createSelector(
    [selectMain],
    (main) => main.isModalLanguagesEnabled
);


// WORKSPACE
export const selectIsModalWorkspaceCreateEnabled = createSelector(
    [selectMain],
    (main) => main.isModalWorkspaceCreateEnabled
);

export const selectIsSidebarWorkspaceMenuEnabled = createSelector(
    [selectMain],
    (main) => main.isSidebarWorkspaceMenuEnabled
);
